import { render } from "./auth.vue?vue&type=template&id=25957014&scoped=true&ts=true"
import script from "./auth.vue?vue&type=script&lang=ts"
export * from "./auth.vue?vue&type=script&lang=ts"

import "./auth.vue?vue&type=style&index=0&id=25957014&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25957014"]])

export default __exports__